// extracted by mini-css-extract-plugin
module.exports = {"img":"HomeSlider_img__mfhfv"};